import catalog from '@/i18n/generated/org-chat-ui-locales.json';
import { normalizeLocale, type SupportedLocale } from '@/i18n/config';
export type OrgChatUiCopy = (typeof catalog)['en'];
export function getOrgChatUiCopy(
  locale: string | null | undefined
): OrgChatUiCopy {
  return catalog[normalizeLocale(locale) as SupportedLocale];
}
